import React, { useEffect, useState } from 'react'
import './profile.scss'
import { ProfilePresenter } from './profile-presenter'
import { investorGeneralSchema } from '../../lib/utils/schema'
import { useNavigate } from 'react-router-dom'
import { userServices } from '../../services'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../store'
import { showBanner } from '../../global-state/banner-slice'
import {
  BasicDetailsProfile,
  isGeneralProfileLocked,
  mapApiProfileToBasicDetails,
} from '../../lib/utils/onboarding'
import {
  applyInvestorKycStateToStore,
  fetchInvestorKycState,
} from '../../lib/utils/sync-investor-kyc-state'

const ProfileContainer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { authToken, email, acceptedNDA, userId } = useSelector(
    (state: RootState) => state.investor,
  )
  const [isKycStateSynced, setIsKycStateSynced] = useState(false)
  const [isUpdateProfile, setIsUpdateProfile] = useState<boolean>(false)
  const [isGeneralProfileReadOnly, setIsGeneralProfileReadOnly] = useState(false)
  const [basicDetailsProfile, setBasicDetailsProfile] = useState<BasicDetailsProfile | null>(null)
  const [initialValuesGeneral, setInitialValuesGeneral] = useState({
    name: '',
    countryOfResidence: '',
    email: email,
    phoneNumber: '',
    citizenship: '',
    countryCode: 'US',
    passportNumber: '',
    whatsappConsent: false,
  })

  useEffect(() => {
    const syncKycState = async () => {
      if (!authToken || !userId) {
        setIsKycStateSynced(true)
        return
      }

      const kycState = await fetchInvestorKycState(userId, authToken)
      if (kycState) {
        applyInvestorKycStateToStore(dispatch, kycState)
      }
      setIsKycStateSynced(true)
    }

    syncKycState()
  }, [authToken, userId, dispatch])

  useEffect(() => {
    const fetchUserProfile = async () => {
      const data = await userServices.getUserProfile_v1({
        Authorization: authToken ? authToken : '',
      })
      if (data && data.data && data.status === 200) {
        setInitialValuesGeneral(data.data)
        setBasicDetailsProfile(
          mapApiProfileToBasicDetails(
            { ...data.data, name: data.data.name ?? '' },
            data.data.email || email,
          ),
        )
        setIsGeneralProfileReadOnly(
          isGeneralProfileLocked(
            Boolean(data.data.basicDetailsCompleted ?? data.data.basic_details_completed),
          ),
        )
      }
    }
    if (authToken) fetchUserProfile()
    else navigate('/')
    setIsUpdateProfile(false)
  }, [isUpdateProfile])

  const handleGeneralFormSubmit = async (val: object) => {
    if (isGeneralProfileReadOnly) return

    const data = await userServices.userProfileUpdate_v1(val, {
      Authorization: authToken ? authToken : '',
    })
    if (!!data && data.status === 200) {
      dispatch(
        showBanner({
          text: 'Profile updated, successfully',
          variant: 'success-banner',
        }),
      )
      setIsUpdateProfile(true)
    } else {
      dispatch(
        showBanner({
          text: data.data.message || 'Something went wrong! Please try again.',
          variant: 'error-banner',
        }),
      )
    }
  }
  return (
    <>
      <ProfilePresenter
        initialValues={initialValuesGeneral}
        investorGeneralSchema={investorGeneralSchema}
        handleGeneralFormSubmit={handleGeneralFormSubmit}
        acceptedNDA={acceptedNDA}
        isKycStateSynced={isKycStateSynced}
        isGeneralProfileReadOnly={isGeneralProfileReadOnly}
        basicDetailsProfile={basicDetailsProfile}
      />
    </>
  )
}

export { ProfileContainer }
